module.exports = {
  HUBSPOT_URL: 'https://api.hsforms.com/submissions/v3/integration/submit',
  LOGIN_FORM: 'login',
  REGISTER_FORM: 'register',
};
